/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u10m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, for maintaining fitness or fitting in movement on a busy day — a focused 10-minute circuit at high intensity raises heart rate and works multiple muscle groups. It won't replace a full training session for building strength or endurance, but it's better than skipping exercise entirely.`)
};

const es_timer_u10m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, para mantener la condición física o incorporar movimiento en un día ocupado — un circuito enfocado de 10 minutos a alta intensidad eleva el ritmo cardíaco y trabaja varios grupos musculares. No reemplaza una sesión de entrenamiento completa para desarrollar fuerza o resistencia, pero es mejor que saltarse el ejercicio por completo.`)
};

const de_timer_u10m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, um die Fitness zu erhalten oder an einem vollen Tag Bewegung einzubauen — ein fokussierter 10-Minuten-Zirkel mit hoher Intensität hebt die Herzfrequenz und trainiert mehrere Muskelgruppen. Er ersetzt keine volle Trainingseinheit für Kraft- oder Ausdaueraufbau, ist aber besser, als das Training ganz ausfallen zu lassen.`)
};

const nl_timer_u10m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, om conditie te onderhouden of beweging in te passen op een drukke dag — een geconcentreerd circuit van 10 minuten op hoge intensiteit verhoogt de hartslag en spreekt meerdere spiergroepen aan. Het vervangt geen volledige trainingssessie voor het opbouwen van kracht of uithoudingsvermogen, maar het is beter dan sporten helemaal overslaan.`)
};

const fr_timer_u10m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, pour maintenir sa forme ou intégrer du mouvement dans une journée chargée — un circuit concentré de 10 minutes à haute intensité augmente le rythme cardiaque et travaille plusieurs groupes musculaires. Cela ne remplace pas une séance complète pour développer force ou endurance, mais c’est mieux que de ne faire aucun exercice.`)
};

const it_timer_u10m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì, per mantenere la forma fisica o inserire del movimento in una giornata impegnativa — un circuito concentrato di 10 minuti ad alta intensità alza la frequenza cardiaca e lavora su più gruppi muscolari. Non sostituirà una sessione di allenamento completa per costruire forza o resistenza, ma è meglio che saltare del tutto l'esercizio.`)
};

const pt_br2_timer_u10m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, para manter o condicionamento físico ou encaixar movimento em um dia corrido — um circuito focado de 10 minutos em alta intensidade eleva a frequência cardíaca e trabalha vários grupos musculares. Não substitui uma sessão de treino completa para ganhar força ou resistência, mas é melhor do que pular o exercício por completo.`)
};

const pt_timer_u10m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, para manter a forma física ou encaixar movimento num dia atarefado — um circuito focado de 10 minutos com alta intensidade eleva o ritmo cardíaco e trabalha vários grupos musculares. Não substitui uma sessão de treino completa para desenvolver força ou resistência, mas é melhor do que saltar o exercício por completo.`)
};

const ja_timer_u10m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、フィットネスの維持や忙しい日に体を動かす機会を確保するには効果的です。高強度で集中した10分間のサーキットは心拍数を上げ、複数の筋肉群を鍛えられます。筋力や持久力を本格的に高めるためのフルトレーニングセッションの代わりにはなりませんが、まったく運動しないよりはるかによい選択です。`)
};

const zh_timer_u10m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有用，尤其是在维持体能或忙碌日子里挤出运动时间方面 — 一次高强度的专注10分钟循环训练能提高心率并锻炼多个肌群。它无法替代完整训练来增强力量或耐力，但总比完全不运动要好。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u10m_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u10m_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u10m_faq3_a", locale)
	if (locale === "en") return en_timer_u10m_faq3_a(inputs)
	if (locale === "es") return es_timer_u10m_faq3_a(inputs)
	if (locale === "de") return de_timer_u10m_faq3_a(inputs)
	if (locale === "nl") return nl_timer_u10m_faq3_a(inputs)
	if (locale === "fr") return fr_timer_u10m_faq3_a(inputs)
	if (locale === "it") return it_timer_u10m_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u10m_faq3_a(inputs)
	if (locale === "pt") return pt_timer_u10m_faq3_a(inputs)
	if (locale === "ja") return ja_timer_u10m_faq3_a(inputs)
	return zh_timer_u10m_faq3_a(inputs)
};